/**
 * Browser entry point. Everything interesting lives in `App.tsx` and
 * `router.tsx` so a test can mount the identical tree without a DOM element or
 * a browser history.
 */
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { createAppQueryClient } from "./queryClient";
import { createAppRouter } from "./router";
import { loadSupportWidget } from "./supportWidget";

const container = document.getElementById("root");
if (!container) {
  throw new Error(
    'index.html is missing <div id="root">. Nothing can mount without it.',
  );
}

const queryClient = createAppQueryClient();
const router = createAppRouter({ queryClient });

createRoot(container).render(
  <StrictMode>
    <App queryClient={queryClient} router={router} />
  </StrictMode>,
);

loadSupportWidget(window.location.hostname, document, window);
